import classnames from 'classnames/bind';
import { FC, ReactNode } from 'react';
import styles from '../styles.module.scss';

const cx = classnames.bind(styles);

type Props = {
  displayName?: ReactNode;
  actionButton?: ReactNode;
  className?: string;
};

export const HeaderSection: FC<Props> = ({
  displayName,
  actionButton,
  className,
}) => {
  return (
    <div className={cx(['headerSectionContainer', className])}>
      {displayName && (
        <div className={cx('headerText')}>
          <div className={cx('headerTextContent')}>{displayName}</div>
        </div>
      )}
      {actionButton}
    </div>
  );
};

HeaderSection.displayName = 'HeaderSection';
